import { render, staticRenderFns } from "./resourceDetailList.vue?vue&type=template&id=dfd8cd8e&scoped=true"
import script from "./resourceDetailList.vue?vue&type=script&lang=js"
export * from "./resourceDetailList.vue?vue&type=script&lang=js"
import style0 from "./resourceDetailList.vue?vue&type=style&index=0&id=dfd8cd8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfd8cd8e",
  null
  
)

export default component.exports